import React from 'react'
import { UserViewModel } from './UserViewModel';
import { NavBarComponente } from '../../Components/NavBarComponente';
import { Container, Row, Image, Col, Form, Button } from 'react-bootstrap';
import fechar from '../../Imagens/close-24.png'; 
import salvar from '../../Imagens/save-16.png'; 

import "../../Estilo/Form.css";
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';
import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";
import Select from 'react-select';
import { ValidaEmail } from '../../Fabrica/ValidaEmail'

interface MyProps {
    navigation: any
    delegate: UserViewControllerDelegate
    viewModel: UserViewModel
    idPrimary: number
}

export interface UserViewControllerDelegate {
    tapDimiss(navigation: any): void
}

export class UserViewController extends React.Component<MyProps>{

    private formEvent: FormEvent
    state = {
        isLoading: false,
        json: {},
        status: [],
        userGroup: [],
        permissions: []
    }

	constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
	}

    componentDidMount() {
        this.loadStatus()
        this.loadUserGroup()
        this.loadPermissions()
        if(this.props.idPrimary > 0) {
            this.loadStruct()
        }
    }

    render() {
        var json = this.state.json as any
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation}/>
                <div>
                    <Container fluid={true}>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Usuários</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                    onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                    src={fechar}/>
                                </div>
                            </Col>
                        </Row>
                        <Form className="containerForm">
                            <Row>
                                <Col lg="4" xs="12" className="bottom10 hide">
                                    <Form.Label>Sequencial</Form.Label>
                                    <Form.Control
                                    id="cusuario"
                                    defaultValue={json['cusuario'] ? json['cusuario'] : ''}
                                    onChange={(e: any) => this.formEvent.onChange("inteiro", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Usuário</Form.Label>
                                    <Form.Control
                                    id="nome"
                                    defaultValue={json['nome'] ? json['nome'] : ''}
                                    onChange={(e: any) => this.formEvent.onChange("user", e.target)}
                                    placeholder="Digite o nome de usuário" 
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Nome Completo</Form.Label>
                                    <Form.Control
                                    id="nomecompleto"
                                    defaultValue={json['nomecompleto'] ? json['nomecompleto'] : ''}
                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                    placeholder="Digite o nome" 
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">E-mail</Form.Label>
                                    <Form.Control
                                    id="email"
                                    defaultValue={json['email'] ? json['email'] : ''}
                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                    placeholder="Digite o e-mail" 
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Ativo</Form.Label>
                                    <Select
                                    id="ativo"
                                    value={this.formEvent.onValueSelect('select', 'ativo', this.state.status)}
                                    onChange={(e: any) => this.formEvent.onChange("select", e, "ativo")}
                                    closeMenuOnSelect={true}
                                    placeholder={"Selecione"}
                                    options={this.state.status}
                                    isMulti={false}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Grupo de Usuário</Form.Label>
                                    <Select
                                    id="grusuario"
                                    value={this.formEvent.onValueSelect('selectMultiple', 'grusuario', this.state.userGroup)}
                                    onChange={(e: any) => this.formEvent.onChange("selectMultiple", e, "grusuario")}
                                    closeMenuOnSelect={true}
                                    placeholder={"Selecione"}
                                    options={this.state.userGroup}
                                    isMulti={true}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Permissões</Form.Label>
                                    <Select
                                    id="permissions"
                                    value={this.formEvent.onValueSelect('selectMultiple', 'permissions', this.state.permissions)}
                                    onChange={(e: any) => this.formEvent.onChange("selectMultiple", e, "permissions")}
                                    closeMenuOnSelect={true}
                                    placeholder={"Selecione"}
                                    options={this.state.permissions}
                                    isMulti={true}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" style={{marginTop: 20}}>
                                    <Button className="buttonSave" type="button" onClick={(e: any) => this.save()} variant="primary">
                                        <Image className="imageSave"
                                        src={salvar}/>
                                        Salvar
                                    </Button>
                                    <Button onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)} className="buttonCancel" variant="link">Cancelar</Button>
                                </Col>
                            </Row>
                        </Form>
                        <ToastContainer />
                    </Container>
                </div>
                <LoaderComponente show={this.state.isLoading} hide={() => this.setState({isLoading: this.state.isLoading})}/>
            </div>
        )
    }

    private loadStatus() {
        var array = Array<any>()
        array.push({value: "S", label: "Sim", check: false})
        array.push({value: "N", label: "Não", check: false})

        this.setState({
            status: array
        })
    }

    private loadUserGroup() {
        this.props.viewModel.fetchSelectUserGroup().then((rs) => {
            var result = rs as Array<any>
            var array = Array<any>()

            for(var i = 0; i < result.length; i++) {
                var item = result[i]
                array.push({value: item.id, label: item.value, check: false})
            }

            this.setState({
                userGroup: array
            })
        });
    }

    private loadPermissions() {
        this.props.viewModel.fetchSelectPermissions().then((rs) => {
            var result = rs as Array<any>
            var array = Array<any>()

            for(var i = 0; i < result.length; i++) {
                var item = result[i]
                array.push({value: item.id, label: item.value, check: false})
            }

            this.setState({
                permissions: array
            })
        });
    }

    private save() {
        var json = this.state.json as any
        if(json["nome"] == undefined || json['nomecompleto'] == undefined || json['email'] == undefined || json['ativo'] == undefined || json['grusuario'] == undefined) {
            this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
            return
        }

        if(json["nome"].length == 0 || json['nomecompleto'].length == 0 || json['email'].length == 0 || json['grusuario'].length == 0) {
            this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
            return
        }

        if(!new ValidaEmail().valida(json['email'])) {
            this.showFieldsEmpty("E-mail inválido!")
            return
        }

        this.props.viewModel.fetchSave(json).then(() => {
            toast.success("Registro incluído com sucesso!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            setTimeout(() => {
                this.props.delegate.tapDimiss(this.props.navigation);
            }, 1000);
        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })
    }

    private showFieldsEmpty(message: string) {
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }

    private loadStruct() {
        var json = this.state.json as any 
        json['cusuario'] = this.props.idPrimary

        this.setState({isLoading: true})
        this.props.viewModel.fetchDataOne(json).then((rs) => {
            var resultado = rs as Array<any>
            if(resultado.length > 0) {
                this.setState({
                    isLoading: false,
                    json: resultado[0]
                })

                return
            }

            this.setState({isLoading: false})
        },e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }
}